import { useState, forwardRef, useImperativeHandle, useContext } from 'react';
import PSAIModal from '@PSAIComponents/PSAIModal';
import styles from './index.module.scss';
import eventBus from '../../../utils/eventBus';
import API from '@api/api'
import { message } from 'antd';
import {  useNavigate } from "react-router-dom";
import { AppContext } from '@utils/AppContext';
import Utils from '@utils/utils'



const ProtocolUpdateModal = forwardRef((props, ref) => {
    const { setGlobaluser } = useContext(AppContext);
    const navigate = useNavigate();
    useImperativeHandle(ref, () => ({
        open: () => setProtocolUpdateVisible(true),
        close: () => setProtocolUpdateVisible(false),
    }));


    const [protocolUpdateVisible, setProtocolUpdateVisible] = useState(false);
    const [orgName, setOrgName] = useState('');
    const [loading, setLoading] = useState(false);

    const confirmAgreement = () => {
        if (!localStorage.getItem('token')) return
        API.confirmAgreement({
        }).then((res) => {
            if (res.code == 0) {
                setProtocolUpdateVisible(false)
                eventBus.emit('updateUserInfo')
            }
        })
    }

    const onClickOk = () => {
        confirmAgreement()
    }

    const hadleLogout = () => {
        API.logout({}).then(res => {
            navigate('/')
            setGlobaluser()
            localStorage.removeItem('token')
            Utils.clearAllTaskCache()
            localStorage.removeItem('channel')
            sessionStorage.removeItem('lastRouteClothes');
            sessionStorage.removeItem('lastRouteCommodity');
            sessionStorage.removeItem('imgResizeCache')
        }).catch((error) => {
            navigate('/')
            localStorage.removeItem('token')
            Utils.clearAllTaskCache()
            localStorage.removeItem('channel')
            sessionStorage.removeItem('lastRouteClothes');
            sessionStorage.removeItem('lastRouteCommodity');
            sessionStorage.removeItem('imgResizeCache')
        })
    }


    return <>
        <PSAIModal
            title='【用户协议】更新声明'
            maxWidth={400}
            okText={'同意并继续'}
            cancelText={'不同意'}
            open={protocolUpdateVisible}
            maskClosable={false}
            okButtonProps={{ disabled: false, loading: loading }}
            onCancel={() => {
                hadleLogout()
                setProtocolUpdateVisible(false)
            }}
            onOk={onClickOk}
            zIndex={1002}
        >
            <div className={styles.ProtocolUpdateWrap}>
                为了提供更优质的服务，我们更新了会员方案。请您充分阅读和理解
                <a className={styles.span_click} href='/服务协议.htm' target="_blank">《服务协议》</a>和
                <a className={styles.span_click} href='/会员条款.htm' target="_blank">《会员条款》</a>。点击“同意并继续”按钮即代表您已同意前述协议全部条款
            </div>
        </PSAIModal>
    </>
})
export default ProtocolUpdateModal
